/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 **/

export { default as ProgramDetailsSettingsContainer } from './components/ProgramDetailsSettingsContainer';
export const ProgramDetailsSettingsContainerDynamic = () => import('./components/ProgramDetailsSettingsContainer');

/**
 *  #################################### Generated content ####################################
 **/
